import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { DeviceService } from './device-detector/device.service';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  private http = inject(HttpClient);
  private deviceService = inject(DeviceService);

  addNewRecord(dto: Record<string, unknown>): void {
    if (!this.deviceService.isPlatformBrowser()) {
      return;
    }

    dto.analyticsVersion = 1;

    this.http.post<void>(`${environment.apiHost}/api/v1/analytics`, dto).subscribe();
  }
}
